module.exports = __webpack_public_path__ + "img/NotificationsNoneOutlined.4b462a2c.svg";